import { RouterProvider } from "react-router-dom";
import {
  PublicServerDataProvider,
  type PublicServerData,
} from "@/features/content/context/PublicServerDataContext";
import { ScrollToTop } from "@/shared/components/ScrollToTop";
import { CookieBanner } from "@/shared/components/CookieBanner";
import { router } from "./routes";

interface AppProps {
  serverData?: PublicServerData | null;
}

export function App({ serverData }: AppProps) {
  return (
    <PublicServerDataProvider serverData={serverData}>
      <RouterProvider router={router} />
      <ScrollToTop />
      <CookieBanner />
    </PublicServerDataProvider>
  );
}
